export default {
  welcome: {
    id: 'welcome_title',
    defaultMessage: 'Howdy',
  },
  allRequests: {
    id: 'asp_nav_item_all_requests',
    defaultMessage: 'All requests',
  },
  feedback: {
    id: 'sav_platform_feedback',
    defaultMessage: 'Give feedback',
  },
  back: {
    id: 'asp_action_bar_navigation_back',
    defaultMessage: 'Back',
  },
  leaveSellerView: {
    id: 'sav_platform_leave_merchant_view',
    defaultMessage: 'Leave seller view',
  },
}
